import { LineSeriesOptions } from "../chart.typings";
import LineSeries from "./lineSeries";
import merge from "lodash/merge";
import { lineSeriesOptions } from "../../../assets/constants";
import { LineType } from "lightweight-charts";

class LineWithMarkersSeries extends LineSeries {

    getDefaultOptions(): LineSeriesOptions {
        const { thickness } = this.config;
        const options: LineSeriesOptions = {
            lineType: LineType.Simple,
            source: "close",
            lineWidth: thickness || 1,
            pointMarkersVisible: true,
            pointMarkersRadius: 3,
        };
        return merge({ ...lineSeriesOptions }, options, this.options)
    }
}

export default LineWithMarkersSeries;
